const translations = {
    headline: {
        type: 'text',
        defaultValue: 'Lista artykułów',
    },
};

export default translations;
